import React, { useState } from "react";
import { toastError } from "@helpers/utils";
import BaseInfiniteLoader, { BaseInfiniteLoaderChildrenProps } from "@reusables/dropdowns/BaseInfiniteLoader/index";

type InifiteLoaderHandlerProps<T> = {
    fetcher: (
        search: string,
        page: number,
        limit: number
    ) => Promise<T[] | undefined>;
    children: (props: BaseInfiniteLoaderChildrenProps<T>) => JSX.Element;
    limit?: number;
};

export default function BaseInfiniteLoaderHandler<T>({
  fetcher,
  children,
  limit = 100
}: InifiteLoaderHandlerProps<T>) {
  const [options, setOptions] = useState<T[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <BaseInfiniteLoader
      fetch={(search, page, limit) => {
        setIsLoading(true);
        fetcher(search, page, limit)
          .then((res) => {
            setOptions(res ?? []);
          })
          .catch((e) => {
            toastError(e);
            console.error("An error occurred in the lazy loader", e);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }}
      limit={limit}
      result={options}
      isLoading={isLoading}
    >
      {(infinity) => children(infinity)}
    </BaseInfiniteLoader>
  );
}